<template>
  <div id="letter-from-our-board-chair" class="section-content">
    <div class="grid-container">
      <div class="board-chair-wrapper grid-x align-center">
        <div class="cell small-10 large-8 board-chair">
          <div class="board-chair__letter"
               data-aos="fade-right"
               data-aos-delay="200"
               data-aos-duration="600"
               data-aos-offset="100">
              <!-- animated shapes -->
              <div class="shape shape--home circle circle--letter"></div>
              <div class="shape shape--home circle circle--letter circle--letter--gray"></div>
              <div class="shape shape--home shape--has-bg triangle triangle--home triangle--home--letter"></div>
              <div class="shape shape--home shape--has-bg dot dot--home dot--home--letter"></div>
            <h3>A Letter from our Board Chair</h3>
            <p>
              The year 2021 was quite a challenge for doctors. The pandemic raged on, and then came labor shortages and inflation. Through all of this, SVMIC doctors continued to take care of their patients. Lives were improved, and communities were supported.  SVMIC understands and greatly appreciates this service.
            </p>
            <p>
              Though these global issues are not under this company’s control, SVMIC remains committed to being a reliable partner. This company will always provide the outstanding legal defense that you deserve and expect from your malpractice insurer. That is a given.
            </p>
            <p>
              SVMIC can help in other ways, too. Our company provides quick connections to capable team members for advice on business challenges such as cyber security and constantly changing regulatory requirements. SVMIC is here to consistently provide careful, compassionate, and efficient service.
            </p>
            <p>
              SVMIC is having to increase premium rates again this year. The amount of the increase will vary by state and will depend upon individual circumstances, but for most doctors the increase will be four percent or less. The increases will begin to take effect on May 15, 2022.
            </p>
            <p>
              The causes of this rate increase are both the long-term upward trend in the frequency of large jury awards and the increased cost of legal defense. Premiums collected must remain in line with the cost of coverage provided.  Please know that your Board of Directors takes this action very seriously and that this decision was made only after careful consideration and analysis.
            </p>
            <p>
              SVMIC was founded with the sole purpose of helping doctors. That will always be the focus. From the physicians on the Board of Directors to the professionals who assist policyholders every day, each SVMIC team member is honored to serve you. Thank you for placing your trust in SVMIC.
            </p>
            <p>Sincerely,</p>
            <div class="board-chair__signature">
              <div class="board-chair__signature__photo"
                 data-aos="zoom-out"
                 data-aos-delay="200"
                 data-aos-duration="1000"
                 data-aos-offset="100">
              </div>
              <div class="board-chair__signature__subtext"
                 data-aos="fade-in"
                 data-aos-delay="400"
                 data-aos-duration="1000"
                 data-aos-offset="100">
              <h5>Hugh Francis, III, MD</h5>
              <p>Chair of the Board</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeLetter'
};
</script>
